import { useState, useEffect, useCallback } from 'react';
import { configuracionAPI } from '../services/api';
import { estaDentroHorarioUso } from '../utils/horariosUso';

/** Estado global de horarios de uso (lectura desde API). */
export function useHorariosUso() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await configuracionAPI.getSistema();
      if (res.success && res.data) {
        setConfig(res.data);
      }
    } catch {
      setConfig(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const check = config ? estaDentroHorarioUso(config) : { permitido: true };

  return {
    config,
    loading,
    refresh,
    permitido: check.permitido,
    motivo: check.motivo || null,
  };
}

/** Devuelve false si la acción debe abortarse por horario. */
export async function assertHorarioUsoCliente() {
  const res = await configuracionAPI.getSistema();
  if (!res.success || !res.data) return true;
  const check = estaDentroHorarioUso(res.data);
  if (!check.permitido) {
    throw new Error(check.motivo || 'Fuera del horario de uso del sistema.');
  }
  return true;
}
